<template>
  <div class="w-full h-full flex flex-col items-center bg-backgroundColor">
    <BannerSection :banner="banner" :loading="loading" />
    <div class="w-[94%] md:w-[75%] 2xl:w-[60%] pt-6 pb-2">
      <div class="flex flex-row items-center text-sm">
        <a href="/"><i class="pi pi-home pr-2 hover:text-seconary"></i>/</a>
        <a href="/news-event"
          ><p class="px-2 hover:text-seconary hover:underline">News & Event</p></a
        >
        /
        <p class="pl-2">Detail</p>
      </div>
      <!-- <CardNewsDetail /> -->
      <div>
        <div v-if="newsDetail" class="w-[94%] md:w-[75%] pt-8">
          <h1 class="font-semibold text-2xl">{{ newsDetail.name }}</h1>
          <div class="mt-5">
            <img :src="newsDetail.imageUrl" class="w-full h-full object-cover" alt="" />
          </div>
          <div class="text-gray-500 text-sm flex items-center pt-2">
            <i class="pi pi-clock"></i>
            <span class="pl-2">{{ formatDate(newsDetail.date) }}</span>
          </div>
          <div
            class="text-base text-gray-800 leading-relaxed pt-5"
            v-html="newsDetail.content"
          ></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import BannerSection from "@/components/BannerSection.vue";
import { db } from "@/firebaseConfig";
import { doc, getDoc, collection, getDocs } from "firebase/firestore";

export default {
  name: "NewsEventDetailPage",
  components: {BannerSection},

  data() {
    return {
      banner: {},
      loading: true,
      newsDetail: null,
    };
  },
  mounted() {
    this.fetchBanner();
    this.fetchNewsDetail();
  },
  methods: {
    async fetchBanner() {
      try {
        const snapshot = await getDocs(collection(db, "newsBannerDetail"));
        const firstDoc = snapshot.docs[0];
        if (firstDoc) {
          this.banner = { id: firstDoc.id, ...firstDoc.data() };
        }
      } catch (e) {
        console.error("Error fetching banner:", e);
      } finally {
        this.loading = false;
      }
    },
    async fetchNewsDetail() {
      const id = this.$route.params.id;
      try {
        const docRef = doc(db, "news", id);
        const docSnap = await getDoc(docRef);
        if (docSnap.exists()) {
          this.newsDetail = { id: docSnap.id, ...docSnap.data() };
        } else {
          console.error("No such news item!");
        }
      } catch (error) {
        console.error("Error fetching news detail:", error);
      }
    },
    formatDate(dateString) {
      if (!dateString) return "";
      const options = { year: "numeric", month: "long", day: "numeric" };
      return new Date(dateString).toLocaleDateString(undefined, options);
    },
  },
};
</script>
